import { useOutsideClick } from '@chakra-ui/hooks';
import { Image } from '@chakra-ui/image';
import { Portal } from '@chakra-ui/portal';
import { Trans } from '@lingui/macro';
import React, {
    useRef,
    useState
} from 'react';

import PppLearningLogo from '../../../assets/icons/3p_learning.svg';
import { useSelectorIsOneRosterActivatedSchool } from '../../app/state/app.selectors';
import { ProductSwitcherMenu } from './components/product-switcher-menu';
import { useMenuGenerator } from './hooks/use-menu-generator';
import { menuConfig } from './product-switcher.config';
import {
    Title,
    ProductSwitcherWrapper,
    ProductSwitcherPopper,
    HeaderAppButton,
    Logo
} from './product-switcher.styled';

export const ProductSwitcher = () => {
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);

    useOutsideClick({
        ref,
        handler: () => setIsOpen(false)
    });

    const productSwitcherMenu = useMenuGenerator(menuConfig);

    if (isOneRosterActivatedSchool) {
        return (
            <HeaderAppButton>
                <ProductSwitcherWrapper data-testid={'product-selector'} onClick={() => setIsOpen(!isOpen)} ref={ref}>
                    <Portal>
                        <ProductSwitcherPopper display={isOpen ? 'flex' : 'none'}>
                            <Title>
                                <Trans id={'productSwitcher.title'} />
                            </Title>
                            {productSwitcherMenu}
                        </ProductSwitcherPopper>
                    </Portal>
                    <ProductSwitcherMenu isOpen={isOpen} />
                </ProductSwitcherWrapper>
            </HeaderAppButton>
        );
    }

    return <Logo><Image src={PppLearningLogo} alt={'3P'} /></Logo>;
};
